import { useEffect } from 'react'

const DEFAULT_FAVICON_HREF = '/logo/M.svg'
const UNREAD_FAVICON_HREF = '/favicon-unread.svg'
const FAVICON_BLINK_INTERVAL_MS = 1000

export const useTicketUnreadFavicon = (isBlinking: boolean) => {
  useEffect(() => {
    const favicon = document.querySelector<HTMLLinkElement>('#app-favicon')

    if (!favicon) {
      return undefined
    }

    const defaultHref = favicon.getAttribute('href') || DEFAULT_FAVICON_HREF

    if (!isBlinking) {
      favicon.setAttribute('href', defaultHref)
      return undefined
    }

    let showUnreadIcon = true
    const renderFavicon = () => {
      favicon.setAttribute(
        'href',
        showUnreadIcon ? UNREAD_FAVICON_HREF : defaultHref,
      )
      showUnreadIcon = !showUnreadIcon
    }

    renderFavicon()
    const intervalId = window.setInterval(
      renderFavicon,
      FAVICON_BLINK_INTERVAL_MS,
    )

    return () => {
      window.clearInterval(intervalId)
      favicon.setAttribute('href', defaultHref)
    }
  }, [isBlinking])
}
